import { Flex, Text } from '@chakra-ui/react'

export const AccessDeniedContainer = () => {
  return (
    <Flex
      alignItems='center'
      display='flex'
      flex={1}
      flexDir='column'
      justifyContent='center'
      p={4}
    >
      <Text fontSize='18px' fontWeight={700}>
        Access Denied
      </Text>
      <Text fontSize='14px' fontWeight={500}>
        Sorry, but you don't have permission to access this Incident
      </Text>
    </Flex>
  )
}
